export default __webpack_public_path__ + "static/media/landspbg.fc3774ab.webp";